var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useId } from 'react';
import classNames from 'classnames';
import { ErrorFieldMessage } from './message';
import { Tooltip } from './Tooltip';
export var RadioButtonInputGroup = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.extraMargin, extraMargin = _b === void 0 ? true : _b, description = _a.description, fieldMessage = _a.fieldMessage, inline = _a.inline, label = _a.label, name = _a.name, selectedValue = _a.selectedValue, tooltip = _a.tooltip, onChange = _a.onChange, rest = __rest(_a, ["children", "className", "extraMargin", "description", "fieldMessage", "inline", "label", "name", "selectedValue", "tooltip", "onChange"]);
    if (tooltip && description) {
        throw new Error('Don\'t use both "tooltip" and "description" on an <RadioButtonInputGroup />, pick one of them');
    }
    var id = useId();
    return (React.createElement("fieldset", __assign({ "aria-labelledby": id, className: classNames('ffe-input-group', { 'ffe-input-group--no-extra-margin': !extraMargin }, { 'ffe-input-group--message': !!fieldMessage }, className) }, rest),
        label && (React.createElement("div", { id: id, className: classNames('ffe-form-label', 'ffe-form-label--block') },
            label,
            typeof tooltip === 'string' && (React.createElement(Tooltip, null, tooltip)),
            React.isValidElement(tooltip) && tooltip)),
        description && (React.createElement("div", { className: "ffe-input-group__description ffe-small-text" }, description)),
        children({
            inline: inline,
            name: name,
            onChange: function (e) {
                onChange === null || onChange === void 0 ? void 0 : onChange(e);
            },
            selectedValue: selectedValue,
        }),
        typeof fieldMessage === 'string' ? (React.createElement(ErrorFieldMessage, { as: "p" }, fieldMessage)) : (fieldMessage)));
};
